import { render, staticRenderFns } from "./QuestionarioCentroOncologia.vue?vue&type=template&id=f793dd12&scoped=true"
import script from "./QuestionarioCentroOncologia.vue?vue&type=script&lang=js"
export * from "./QuestionarioCentroOncologia.vue?vue&type=script&lang=js"
import style0 from "./QuestionarioCentroOncologia.vue?vue&type=style&index=0&id=f793dd12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f793dd12",
  null
  
)

export default component.exports